module.exports = __webpack_public_path__ + "img/oval.be5030ca.webp";